<template>
  <div class="bg-gray-600">
    <div class="flex align-items-center flex-wrap p-4 py-2">
      <div class="flex align-items-center flex-wrap mr-4" v-show="companyAdmin">
        <a
          class="
            hover:no-underline
            text-white
            rounded
            p-2
            border-green-500
            bg-green-400
            hover:bg-green-300
            text-center
            w-48
          "
          v-if="showViewCompany()"
          href="#"
          @click.prevent="loginAsCompany"
          >View as Company</a
        >
        <a
          class="
            hover:no-underline
            text-white
            rounded
            p-2
            border-green-500
            bg-green-400
            hover:bg-green-300
            text-center
            w-48
          "
          v-else
          href="#"
          @click.prevent="logOutCompany"
          >View as Agent</a
        >
      </div>

      <div
        class="flex align-items-center flex-wrap mr-4"
        v-show="officeAdmin && !companyAdmin"
      >
        <a
          class="
            hover:no-underline
            text-white
            rounded
            p-2
            border-green-500
            bg-green-400
            hover:bg-green-300
            text-center
            w-48
          "
          v-if="showViewOffice()"
          href="#"
          @click.prevent="loginAsOffice"
          >View as Office</a
        >
        <a
          class="
            hover:no-underline
            text-white
            rounded
            p-2
            border-green-500
            bg-green-400
            hover:bg-green-300
            text-center
            w-48
          "
          v-else
          href="#"
          @click.prevent="logOutOffice"
          >View as Agent</a
        >
      </div>

      <div
        class="flex align-items-center mr-2"
        v-show="companyAdmin && showOffices()"
      >
        <div class="lead text-gray-200 mr-2">Office:</div>
        <vue-bootstrap-typeahead
          class="mx-2"
          style="width: 300px"
          :data="getOfficeData()"
          :placeholder="officePlaceholder"
          size="lg"
          :serializer="(s) => s.OFFname"
          v-model="offices"
          @hit="selectOffice($event)"
          ref="officeInput"
          ignore
        />
      </div>

      <div class="flex align-items-center">
        <p class="lead text-gray-200 mr-2">Realtor:</p>
        <vue-bootstrap-typeahead
          class="mx-2"
          style="width: 300px"
          :data="agents"
          :placeholder="realtorPlaceholder"
          size="lg"
          :serializer="(s) => s.name"
          v-model="agentSearch"
          @hit="selectAgent($event)"
          ref="realtorInput"
          ignore
        />
      </div>

      <span class="pl-1 text-white" v-if="loading">
        Loading <i class="fas fa-spinner fa-spin mt-3 ml-2"></i>
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getCookie } from "../../cookie";

export default {
  data() {
    return {
      agents: [],
      agentSearch: "",
      offices: "",
      loading: false,
    };
  },
  methods: {
    showViewCompany() {
      if (this.me.isImpersonated) {
        return this.me.impersonated.loggedInAs !== "company";
      } else {
        return this.me.tokenUser.loggedInAs !== "company";
      }
    },
    showViewOffice() {
      if (this.me.isImpersonated) {
        return this.me.impersonated.loggedInAs !== "office";
      } else {
        return this.me.tokenUser.loggedInAs !== "office";
      }
    },
    getOfficeData() {
      if (this.me.isImpersonated) {
        switch (this.me.impersonated.loggedInAs) {
          case "company":
            return this.me.impersonated.offices;
          case "office":
            return this.me.impersonated.company.offices;
          case "realtor":
            return this.me.impersonated.company.offices;
        }
      } else if (this.me.tokenUser) {
        return this.me.tokenUser ? this.me.tokenUser.company.offices : [];
      }
    },
    showOffices() {
      if (this.me.isImpersonated) {
        switch (this.me.impersonated.loggedInAs) {
          case "company":
            return this.me.impersonated.offices.length;
          case "office":
            return this.me.impersonated.company.offices.length;
          case "realtor":
            return this.me.impersonated.company.offices.length;
        }
      } else if (this.me.tokenUser) {
        return this.me.tokenUser.company.offices.length;
      }
    },
    selectAgent(e) {
      this.changeIdentity(e.id);
    },

    searchAgents(v) {
      this.$http.get("/admin/realtorSearch?search=" + v).then((response) => {
        this.agents = response.data;
      });
    },
    changeIdentity(id) {
      // Set new Cookie
      let newToken = getCookie("token").split(",")[0] + `,realtor,${id}`;

      // Show loading icon
      this.loading = true;
      let vm = this;
      let type = getCookie("companyAdmin") ? "companyAdmin" : "officeAdmin";

      // Call to update session
      this.$http.get("/switchUser/" + id).then(() => {
        // Hide loading icon
        vm.loading = false;

        window.location.href = "/?token=" + newToken + "&type=" + type;
      });
    },
    logOutCompany() {
      let vm = this;

      vm.loading = true;

      this.changeIdentity(vm.me.tokenUser.id);
    },
    loginAsCompany() {
      let vm = this;
      let id =
        this.$helpers.get(["company", "id"], this.me.impersonated) ||
        vm.me.tokenUser.company.id;

      let newToken = getCookie("token").split(",")[0] + `,company,${id}`;

      let type = "companyAdmin";

      vm.loading = true;
      // console.log(uri);
      window.location.href = "/?token=" + newToken + "&type=" + type;
    },
    loginAsOffice() {
      let vm = this;
      vm.loading = true;

      // this.changeIdentity(vm.me.tokenUser.id)
      let office = vm.me.isImpersonated
        ? vm.me.impersonated.office.id
        : vm.me.tokenUser.office.id;
      this.changeOffice(office);
    },
    logOutOffice() {
      this.loading = true;
      this.changeIdentity(this.me.tokenUser.id);
    },
    changeOffice(id) {
      let vm = this;
      let newToken = getCookie("token").split(",")[0] + `,office,${id}`;
      let type = getCookie("companyAdmin") ? "companyAdmin" : "officeAdmin";

      vm.loading = true;

      // Call to update session
      this.$http.get("/switchOffice/" + id).then(() => {
        // Hide loading icon
        vm.loading = false;

        window.location.href = "/?token=" + newToken + "&type=" + type;
      });
    },
    selectOffice(office) {
      let vm = this;

      let newToken =
        getCookie("token").split(",")[0] + `,office,${office.OFFid}`;
      let type = getCookie("companyAdmin") ? "companyAdmin" : "officeAdmin";

      vm.loading = true;

      // Call to update session
      this.$http.get("/switchOffice/" + office.OFFid).then(() => {
        // Hide loading icon
        vm.loading = false;

        window.location.href = "/?token=" + newToken + "&type=" + type;
      });
    },
  },
  watch: {
    agentSearch(v) {
      this.searchAgents(v);
    },

    me(v) {
      if (typeof this.langCode !== "undefined" && this.langCode === "fr-CA") {
        window.Localize.initialize({
          key: "VlbE8RtdbnJqb",
          targetLanguage: this.langCode
          // other options go here, separated by commas
        });
      }

      if (v.isImpersonated) {
        switch (this.me.impersonated.loggedInAs) {
          case "company":
            this.$refs.officeInput.inputValue = "";
            this.$refs.realtorInput.inputValue = "";
            break;
          case "office":
            this.$refs.officeInput.inputValue = v.impersonated.name;
            this.$refs.realtorInput.inputValue = "";
            break;
          case "realtor":
            this.$refs.officeInput.inputValue = v.impersonated.office.name;
            this.$refs.realtorInput.inputValue = v.impersonated.name;
            break;
        }
      } else {
        this.$refs.officeInput.inputValue = v.tokenUser.office.name;
        this.$refs.realtorInput.inputValue = v.tokenUser.name;
      }
    },
  },
  computed: {
    ...mapGetters(["me"]),
    officeAdmin() {
      return getCookie("officeAdmin");
    },
    companyAdmin() {
      return getCookie("companyAdmin");
    },
    langCode() {
      if (
        typeof this.me.tokenUser.preferences !== "undefined" &&
        typeof this.me.tokenUser.preferences[719] !== "undefined"
      ) {
        return this.me.tokenUser.preferences[719].PREFvalue;
      }
      return "en";
    },
    realtorPlaceholder() {
      return this.langCode === "fr-CA"
        ? "Rechercher un courtier..."
        : "Search Realtors...";
    },
    officePlaceholder() {
      return this.langCode === "fr-CA"
        ? "Sélectionner un bureau..."
        : "Select Office...";
    },
  },
};
</script>

<style lang="scss">
.dashboardTopBar {
  .dropdown-menu {
    overflow: scroll;
    max-height: 500px;
  }
}

.active-buttons {
  background: #575656;
  border-radius: 3px;
  padding-right: 4px;
  padding-top: 8px;

  .btn {
    border-radius: 3px;
    margin-left: 4px;

    color: #999;

    &.active,
    &:hover {
      background: #999;
      color: #fff;
    }

    /*padding: 5px;*/
  }
}
</style>
